import { languageMap } from ".."

languageMap.elixir = {
	comments: {
		line: "#",
	},
}
